<template>
	<v-dialog v-model="dialog" persistent max-width="900px">
		<v-card>
			<s-toolbar
				label="Agregar Salida de Kit de Seguridad"
				dark
				close
				:color="'primary'"
				@close="close()"
				save
				@save="save()"
			></s-toolbar>
			<v-card-text>
				<v-container>
					<v-row>
						<v-col cols="12" md="6" class="s-col-form">
							<s-search-requirement 
								ref="searchRequirement"
								label="Buscar Requerimiento"
								@select="selectRequirement($event)"
								@found="requirementFound($event)"
								@clear="clearRequirement"
							/>
						</v-col>
					</v-row>

					<v-row v-if="selectedRequirementDetails.length > 0">
						<v-col cols="12">
							<v-divider class="my-3"></v-divider>
							<h4 class="mb-3">Detalles del Requerimiento Seleccionados</h4>
						</v-col>
					</v-row>

					<v-row 
						v-for="(detail, index) in selectedRequirementDetails" 
						:key="'detail-' + index"
						class="mb-2"
					>
						<v-col cols="12">
							<v-card outlined>
								<v-card-title class="py-2">
									<span class="subtitle-2">
										{{ detail.DerDescription }} - Req: {{ detail.ReqDocumentNumber }}
									</span>
									<v-spacer></v-spacer>
									<v-btn icon small color="error" @click="removeDetail(index)">
										<v-icon small>mdi-delete</v-icon>
									</v-btn>
								</v-card-title>
								<v-card-text>
									<v-row>
										<v-col cols="12">
											<span class="subtitle-2">Cantidad Requerida: {{ detail.DerQuantity }}</span>
										</v-col>
									</v-row>
									<v-row>
										<v-col 
											v-for="(seal, sIndex) in detail.Seals" 
											:key="'seal-' + index + '-' + sIndex"
											cols="12" 
											md="3" 
											class="s-col-form"
										>
											<s-text 
												:label="'Cod. Kit Seguridad ' + (sIndex + 1)" 
												v-model="seal.SlsCodeSeal"
												:ref="'sealInput-' + index + '-' + sIndex"
												@keydown.enter.native="focusNextSeal(index, sIndex)"
											/>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>
						</v-col>
					</v-row>
				</v-container>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
	import SSearchRequirement from '@/components/logistics/SSearchRequirement.vue';
    import _sExitSealsService from '@/services/Logistics/LgsExitSealsService.js';

	export default {
        name: "ExitSealsAddDialog",
		components: {
			SSearchRequirement
		},
        props: {
            value: {
                type: Boolean,
                default: false
            }
        },
		data() {
			return {
				selectedRequirementDetails: [],
			}
		},
        computed: {
            dialog: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                }
            }
        },
		methods: {
            close() {
                this.dialog = false;
                this.selectedRequirementDetails = [];
				if(this.$refs.searchRequirement) {
					this.$refs.searchRequirement.clearable(); 
				}
            },
			async selectRequirement(data) {
				console.log("Requerimiento seleccionado:", data);
				
				if (data.selectedDetails && data.selectedDetails.length > 0) {
					if (this.selectedRequirementDetails.length > 0) {
						const currentReqID = this.selectedRequirementDetails[0].ReqID;
						
						if (currentReqID !== data.requirement.ReqID) {
							const result = await this.$fun.alert(
								`Ya tiene detalles agregados del requerimiento ${this.selectedRequirementDetails[0].ReqDocumentNumber}. ¿Desea reemplazarlos con los detalles del requerimiento ${data.requirement.ReqDocumentNumber}?`,
								"question"
							);
							
							if (!result.value) {
								return;
							}
							
							this.selectedRequirementDetails = [];
						}
					}
					
					const newDetails = data.selectedDetails.filter(detail => {
						return !this.selectedRequirementDetails.some(existing => existing.DerID === detail.DerID);
					});
					
					if (newDetails.length === 0) {
						this.$fun.alert("Todos los detalles seleccionados ya han sido agregados", "warning");
						return;
					}
					
					const detailsToAdd = newDetails.map(detail => {
						const quantity = detail.DerQuantity || 1;
						const seals = [];
						for (let i = 0; i < quantity; i++) {
							seals.push({ SlsCodeSeal: "" });
						}

						return {
							...detail,
							Seals: seals,
							SlsContainer: "",
							SlsOV: "",
							ReqDocumentNumber: data.requirement.ReqDocumentNumber,
							ReqID: data.requirement.ReqID
						};
					});
					
					this.selectedRequirementDetails = [...this.selectedRequirementDetails, ...detailsToAdd];
					
					const skipped = data.selectedDetails.length - newDetails.length;
					let message = `${newDetails.length} detalle(s) agregado(s) del requerimiento ${data.requirement.ReqDocumentNumber}`;
					if (skipped > 0) {
						message += `. ${skipped} detalle(s) ya estaban agregados`;
					}
					this.$fun.alert(message, "success");
				}
			},
			requirementFound(requirement) {
				console.log("Requerimiento encontrado:", requirement);
			},
			clearRequirement() {
				console.log("Búsqueda de requerimiento limpiada");
			},
			removeDetail(index) {
				this.selectedRequirementDetails.splice(index, 1);
			},
			focusNextSeal(detailIndex, sealIndex) {
				let nextSealIndex = sealIndex + 1;
				let nextDetailIndex = detailIndex;

				if (nextSealIndex >= this.selectedRequirementDetails[detailIndex].Seals.length) {
					nextDetailIndex++;
					nextSealIndex = 0;
				}

				if (nextDetailIndex < this.selectedRequirementDetails.length) {
					const refKey = `sealInput-${nextDetailIndex}-${nextSealIndex}`;
					const nextInputRef = this.$refs[refKey];
					
					const nextInput = Array.isArray(nextInputRef) ? nextInputRef[0] : nextInputRef;

					if (nextInput) {
                        if (nextInput.focus) {
                             nextInput.focus();
                        } else if (nextInput.$el && nextInput.$el.querySelector('input')) {
                             nextInput.$el.querySelector('input').focus();
                        }
					}
				}
			},
            async save() {

				if(this.selectedRequirementDetails.length === 0) {
					this.$fun.alert("No hay detalles para guardar", "warning");
					return;
				}
				
                const confirm = await this.$fun.alert("¿Está seguro de guardar los cambios?", "question");
				if (!confirm.value) return;

                try {
                    const promises = [];
                    
                    this.selectedRequirementDetails.forEach(detail => {
                        detail.Seals.forEach(seal => {
                            if (seal.SlsCodeSeal && seal.SlsCodeSeal.trim()) {
                                const payload = {
                                    SlsID: 0,
                                    ReqID: detail.ReqID,
                                    DerID: detail.DerID,
                                    SlsCodeSeal: seal.SlsCodeSeal.trim(),
									DerNumLine: detail.DerNumLine,
									ArtCode: detail.ArtCode,
									UsrCreateID: this.$fun.getUserID(),
                                };
                                promises.push(_sExitSealsService.save(payload, this.$fun.getUserID()));
                            }
                        });
                    });

                    await Promise.all(promises);
                    
                    this.$fun.alert("Guardado correctamente", "success");
                    this.$emit('saved');
                    this.close();
                } catch (error) {
                    console.error("Error saving seals:", error);
                }
            }
		},
	}
</script>
